import PouchDB from 'pouchdb';
import PouchDBErase from 'pouchdb-erase';
import PouchDBFind from 'pouchdb-find';
import PouchDBUpsert from 'pouchdb-upsert';

/**
 * Einmalige PouchDB-Plugin-Registrierung.
 * Diese Datei MUSS vor jeder PouchDB-Verwendung importiert werden.
 *
 * Plugins:
 * - pouchdb-erase: db.erase() zum vollständigen Löschen
 * - pouchdb-find: db.createIndex(), db.find() für Mango-Queries
 * - pouchdb-upsert: db.upsert() für conditional updates
 */

// Einmalige Plugin-Registrierung
PouchDB.plugin(PouchDBErase);
PouchDB.plugin(PouchDBFind);
PouchDB.plugin(PouchDBUpsert);

// PouchDB als Default-Export bereitstellen
export { PouchDB };
export default PouchDB;
